<template>
  <div v-if="enabled" class="styled-breadcrumb-wrapper" v-bind="$attrs">
    <slot></slot>
  </div>
  <slot v-else v-bind="$attrs"></slot>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    enabled: boolean
  }>(),
  {
    enabled: false,
  },
)
</script>

<style lang="scss" scoped>
@import '@/scss/variables';

.styled-breadcrumb-wrapper {
  width: 100%;
  background-color: c('white');
  border-width: 1px 0 1px 0;
  border-style: solid;
  border-color: c('gunmetal-14');
  padding: 1rem 5rem;
}
</style>
